// eslint-disable-next-line import/prefer-default-export
export const GLOBAL_LANGUAGE_ID = 'c5eb9158-3f56-4113-8a82-02c69060a677';
export const ANALYTICS_ENABLED = process.env.ANALYTICS_ENABLED ? process.env.ANALYTICS_ENABLED === 'true' : true;
export const HIDE_FROM_SCREENSHOT_CLASS = '___hide-from-screenshot';
export const HIDDEN_FROM_SCREENSHOT_CLASS = '___hidden-from-screenshot';
